<template>
  <div class="beesindex-index-warp">
    <van-sticky>
      <headerItem titleName="团队工单管理" type="group" />
    </van-sticky>
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh" :head-height="80" success-text="刷新成功">
      <div class="beesindex-index-item">
        <groupIndexItem :formData="formData"/>
      </div>
    </van-pull-refresh>
  </div>
</template>

<script>
import headerItem from "./components/header";
import groupIndexItem from "./components/groupIndexItem";
export default {
  data() {
    return {
      refreshing: false,
      formData:{}
    };
  },
  created() {
    this.$loading.hide();
  },
  methods: {
    onRefresh() {
      setTimeout(() => {
        this.getData();
       
      }, 800);
    },
    getData(){
      this.http({
        url:'/order/manage/warning/app/getTeamWarningOrderSummary',
        method:'post',
        parmes:{type:2}
      }).then(rps=>{
        if(rps.code==200){
          this.formData = rps.data;
           this.refreshing = false;
          this.$loading.hide();
        }
      })
    }
  },
  components: { headerItem, groupIndexItem },
  created(){
    this.getData();
  },
  activated(){
    this.$loading.hide();
  }
};
</script>

<style lang="less" scoped>
</style>